import { render } from "./bind_risk_framework.html?vue&type=template&id=78001e68&external"
import script from "./bind_risk_framework.js?vue&type=script&lang=js&external"
export * from "./bind_risk_framework.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__